import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilterSearchCustomerStatement } from '../models/filter-search-customer-statement-model';
import { SummarySendMail } from 'app/core/_base/crud/models/summary-send-mail-model';
import { EdiCustomerAddress } from '../../admin/models/edi-customer-address-model';
import { TariffFlagDTO } from '../../processing/models/sale-order-data-model';
import { DeliveryRecommendationModel } from 'app/core/cnc/admin/models/delivery-recommendation-model';
import { AddressResponse } from '../models/status-model';


@Injectable({
    providedIn: 'root'
})
export class CustomersService {
    /**
     * Url for address code API Rest
     */
    private API_ADDRESS_CODE_URL = environment.ipserver + 'o2c-backend/private/customerStatement/addressCode';

     private API_TARIFF_CODE_URL = environment.ipserver + 'o2c-backend/private/customerStatement/tarriffFlag';

      private API_VALIDATE_ADDRESS_CODE_URL = environment.ipserver + 'o2c-backend/private/customerStatement/validateAddressCode';


    /**
     * Url for emails by customer API Rest
     */
    private API_EMAILS_URL = environment.ipserver + 'o2c-backend/private/customerStatement/emails';

    /**
     * Url for send emails by customer API Rest
     */
    private API_SEND_EMAILS_URL = environment.ipserver + 'o2c-backend/private/customerStatement/sendEmail';
    /**
     * Url for customer statement search API Rest
     */
    private API_SEARCH_URL = environment.ipserver + 'o2c-backend/private/customerStatement/generate';
	private API_SFADDRESS_CODE_URL = environment.ipserver + 'o2c-backend/private/customerStatement/sfaddress';
    private API_GET_DELIVERY_AND_FREIGHT = environment.ipserver + 'o2c-backend/private/customerStatement/getDeliverAndFreight';


    constructor(
        private httpClient: HttpClient
    ) { }


    /**
     * Method that obtains a list of Address code by calling a rest service
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-05-18
     * @param customer customer string
     * @return Observable with a array of strings address code
     */
    getAddressCode(customer: string, division?: string): Observable<string[]> {
        let paramsForReq = new HttpParams()
            .set('customerNumber', customer);
        if (division) {
            paramsForReq = new HttpParams()
                .set('customerNumber', customer)
                .set('division', division);
        }
        return this.httpClient.get<string[]>(this.API_ADDRESS_CODE_URL, { params: paramsForReq });
    }

     validateAddressCode(customer: string, addressCode: string): Observable<AddressResponse> {
        let paramsForReq = new HttpParams()
            .set('customerNumber', customer)
            .set('addressCode', addressCode);
        return this.httpClient.get<AddressResponse>(this.API_VALIDATE_ADDRESS_CODE_URL, { params: paramsForReq });
    }


     getTariffFlags(customer: string, division: string, addressCode:string, warehouse:string): Observable<TariffFlagDTO> {
       
           let paramsForReq = new HttpParams()
                .set('customerNumber', customer)
                .set('addressCode', addressCode)
                .set('warehouse', warehouse)
                .set('division', division);
        
        return this.httpClient.get<TariffFlagDTO>(this.API_TARIFF_CODE_URL, { params: paramsForReq });
    }

	 /**
     * Method that obtains a list of Address code by calling a rest service
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-05-18
     * @param customer customer string
     * @return Observable with a array of strings address code
     */
	 getSFAddress(customer: string, warehouse: string, otherAddressID : string): Observable<EdiCustomerAddress[]> {
        let paramsForReq = new HttpParams()
            .set('customerNumber', customer)
			.set('id', otherAddressID)
			.set('warehouse', warehouse);


        return this.httpClient.get<EdiCustomerAddress[]>(this.API_SFADDRESS_CODE_URL, { params: paramsForReq });
    }

    /**
     * Method that obtains a list of emails from customer by calling a rest service
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-05-20
     * @return Observable with a array of strings address code
     */
    getEmailsFromCustomer(division: string, customerNumber: string, addressCodes: string): Observable<string[]> {
        const paramsForReq = new HttpParams()
            .set('division', division)
            .set('customerNumber', customerNumber)
            .set('addressCodes', addressCodes);
        return this.httpClient.get<string[]>(this.API_EMAILS_URL, { params: paramsForReq });
    }

    /**
     * Method that send a list of emails from customer by calling a rest service
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-05-20
     * @return Observable with a array of strings address code
     */
    sendEmailsFromCustomer(emails: string[], filters: FilterSearchCustomerStatement): Observable<SummarySendMail[]> {
        const paramsForReq = new HttpParams()
            .set('division', filters.division)
            .set('customerNumber', filters.customerNumber)
            .set('addressCodes', filters.addressCodes)
            .set('statementDate', filters.statementDate)
            .set('asOfDate', filters.asOfDate)
            .set('transactionType', filters.transactionType);
        // const type = 'text' as 'json';
        let header = new HttpHeaders();
        header = header.append('content-type', 'application/json');
        return this.httpClient.post<SummarySendMail[]>(this.API_SEND_EMAILS_URL, emails, { params: paramsForReq, headers: header });
    }

    /**
     * Method that send a list of emails from customer by calling a rest service
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-05-20
     * @return Observable with a array of strings address code
     */
    searchCustomerStatements(filters: FilterSearchCustomerStatement): Observable<any> {
        const paramsForReq = new HttpParams()
            .set('division', filters.division)
            .set('customerNumber', filters.customerNumber)
            .set('addressCodes', filters.addressCodes)
            .set('statementDate', filters.statementDate)
            .set('asOfDate', filters.asOfDate)
            .set('transactionType', filters.transactionType);
        const type = 'text' as 'json';
        return this.httpClient.post(this.API_SEARCH_URL, '', { params: paramsForReq, responseType: type });
    }

    getDeliveryAndFreightRecommendations(customerNumber: string, deliveryAddress: string): Observable<DeliveryRecommendationModel> {
        const params = new HttpParams()
            .set('customerNumber', customerNumber)
            .set('deliveryAddress', deliveryAddress);      
        return this.httpClient.get<DeliveryRecommendationModel>(this.API_GET_DELIVERY_AND_FREIGHT, { params });
    }
      
}
